export default "__VITE_ASSET__DsLkx4IN__"